import React from 'react'
import Featured from '../../components/featured/Featured'
import FeaturedProperties from '../../components/featuredProperties/FeaturedProperties'
import Footer from '../../components/footer/Footer'
import Header from '../../components/header/Header'
import MailList from '../../components/mailList/MailList'
import Navbar from '../../components/navbar/Navbar'
import PropertyList from '../../components/propertyList/propertyList';

function Home() {
    return (
        <div>
            <Navbar />
            <Header />
            <div className='flex flex-col items-center p-3 mt-12 gap-7'>
                <h1 className='text-2xl font-bold'>Browse by Room type</h1>
                <Featured />
                <h1 className='text-2xl font-bold'>Browse by property type</h1>
                <PropertyList />
                <h1 className='text-2xl font-bold'>Home guests love</h1>
                <FeaturedProperties />
                <MailList />
                <Footer />
            </div>
        </div>
    )
}

export default Home